import React, { useEffect, useRef, useState } from "react";
import { Box, Button } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";

export default function WebMatchSelectionShapeText({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const audioResources = ResourceLinks.audio;

    // for Zone 1
    const [selectedKeyPreviousZone1, setSelectedKeyPreviousZone1] = useState(null);
    const [availableChoicesZone1, setAvailableChoicesZone1] = useState(
        data.zone1.choices
    );
    const [selectedChoiceZone1, setSelectedChoiceZone1] = useState(null);

    // for Zone 2
    const [selectedKeyPreviousZone2, setSelectedKeyPreviousZone2] = useState(null);
    const [availableChoicesZone2, setAvailableChoicesZone2] = useState(
        data.zone2.choices
    );
    const [selectedChoiceZone2, setSelectedChoiceZone2] = useState(null);

    // for Zone 3
    const [selectedKeyPreviousZone3, setSelectedKeyPreviousZone3] = useState(null);
    const [availableChoicesZone3, setAvailableChoicesZone3] = useState(
        data.zone3.choices
    );
    const [selectedChoiceZone3, setSelectedChoiceZone3] = useState(null);

    const [answer, setAnswer] = useState(data.initalAnswer);

    const [answerZone1, setAnswerZone1] = useState([]);
    const [answerZone2, setAnswerZone2] = useState({
        "left": [

        ],
        "right": [

        ],
    });
    const [answerZone3, setAnswerZone3] = useState([]);

    // for audio header
    const audioInfo = data.audioInfo;
    const [playingAudioUrl, setPlayingAudioUrl] = useState("");
    const refs = useRef({});

    useEffect(() => {
        let canProceed = false;
        if (answerZone1.length > 0) {
            canProceed = true;
        }

        if (answerZone2["left"].length > 0 || answerZone2["right"].length > 0) {
            canProceed = true;
        }

        if (answerZone3.length > 0) {
            canProceed = true;
        }

        onAnswer({
            canProceed,
            answer: answer,
        })

    }, [answer, answerZone1, answerZone2, answerZone3, onAnswer]);

    // for Zone 1
    const handleChoiceClickZone1 = (choice) => {
        setSelectedChoiceZone1(choice);
    };

    // for Zone 2
    const handleChoiceClickZone2 = (choice) => {
        setSelectedChoiceZone2(choice);
    };

    // for Zone 3
    const handleChoiceClickZone3 = (choice) => {
        setSelectedChoiceZone3(choice);
    };

    const handleClickAssignedZone1 = () => {
        let selectedChoice = null;
        let originalZone = null;
        if (selectedChoiceZone1 && selectedKeyPreviousZone1 === null) {
            selectedChoice = selectedChoiceZone1;
            originalZone = 1;
            if (selectedKeyPreviousZone1 !== null) {
                originalZone = selectedKeyPreviousZone1.originalZone;
            }
        } else if (selectedChoiceZone2) {
            selectedChoice = selectedChoiceZone2;
            originalZone = 2;
            if (selectedKeyPreviousZone2 !== null) {
                originalZone = selectedKeyPreviousZone2.originalZone;
            }
        } else if (selectedChoiceZone3) {
            selectedChoice = selectedChoiceZone3;
            originalZone = 3;
            if (selectedKeyPreviousZone3 !== null) {
                originalZone = selectedKeyPreviousZone3.originalZone;
            }
        }

        // if zone  was selected
        if (selectedChoice) {

            let ans = {...answer};
            ans["zone1"].push(selectedChoice.stateKey);
            setAnswer(ans);
            
            // for setting the zone 1 answers
            setAnswerZone1((answerZone1) => [
                ...answerZone1,
                {
                    "zone": 1,
                    "shape": selectedChoice.shape,
                    "value": selectedChoice.value,
                    "style": selectedChoice.style,
                    "stateKey": selectedChoice.stateKey,
                    "originalZone": originalZone,
                }
            ])

            handlingAddChoice();
        }
    };

    const handleClickAssignedZone2 = (position) => {
        let selectedChoice = null;
        let originalZone = null;
        if (selectedChoiceZone1) {
            selectedChoice = selectedChoiceZone1;
            originalZone = 1;
            if (selectedKeyPreviousZone1 !== null) {
                originalZone = selectedKeyPreviousZone1.originalZone;
            }
        } else if (selectedChoiceZone2 && (selectedKeyPreviousZone2 === null || selectedKeyPreviousZone2?.position !== position)) {
            selectedChoice = selectedChoiceZone2;
            originalZone = 2;
            if (selectedKeyPreviousZone2 !== null) {
                originalZone = selectedKeyPreviousZone2.originalZone;
            }
        } else if (selectedChoiceZone3) {
            selectedChoice = selectedChoiceZone3;
            originalZone = 3;
            if (selectedKeyPreviousZone3 !== null) {
                originalZone = selectedKeyPreviousZone3.originalZone;
            }
        }

        // if zone was selected
        if (selectedChoice !== null) {
            // set answer
            let ans = {...answer};
            ans["zone2"][position].push(selectedChoice.stateKey);
            setAnswer(ans);

            // for setting the zone 2 answers
            let ansZone2 = {...answerZone2}
            ansZone2[position].push({
                "zone": 2,
                "shape": selectedChoice.shape,
                "value": selectedChoice.value,
                "style": selectedChoice.style,
                "stateKey": selectedChoice.stateKey,
                "originalZone": originalZone,
                "position": position
                
            });
            setAnswerZone2(ansZone2);

            handlingAddChoice();
        }
    };

    const handleClickAssignedZone3 = () => {
        let selectedChoice = null;
        let originalZone = null;
        if (selectedChoiceZone1) {
            selectedChoice = selectedChoiceZone1;
            originalZone = 1;
            if (selectedKeyPreviousZone1 !== null) {
                originalZone = selectedKeyPreviousZone1.originalZone;
            }
        } else if (selectedChoiceZone2) {
            selectedChoice = selectedChoiceZone2;
            originalZone = 2;
            if (selectedKeyPreviousZone2 !== null) {
                originalZone = selectedKeyPreviousZone2.originalZone;
            }
        } else if (selectedChoiceZone3 && selectedKeyPreviousZone3 === null) {
            selectedChoice = selectedChoiceZone3;
            originalZone = 3;
            if (selectedKeyPreviousZone3 !== null) {
                originalZone = selectedKeyPreviousZone3.originalZone;
            }
        }

        // if zone was selected
        if (selectedChoice !== null) {

            let ans = {...answer};
            ans["zone3"].push(selectedChoice.stateKey);
            setAnswer(ans);
            
            // for setting the zone 3 answers
            setAnswerZone3((answerZone3) => [
                ...answerZone3,
                {
                    "zone": 3,
                    "value": selectedChoice.value,
                    "stateKey": selectedChoice.stateKey,
                    "shape": selectedChoice.shape,
                    "style": selectedChoice.style,
                    "originalZone": originalZone,
                }
            ])

            handlingAddChoice();
        }
    };

    const handleRemoveChoiceZone1 = (curentAnswer) => {
        handlingRemoveChoice(curentAnswer, "");
    }

    const handleRemoveChoiceZone2 = (curentAnswer, position) => {
        handlingRemoveChoice(curentAnswer, position);
    }

    const handleRemoveChoiceZone3 = (curentAnswer) => {
        handlingRemoveChoice(curentAnswer, "");
    }

    const removeValueInArray = (array, value) => {
        let index = array.indexOf(value);
        if (index !== -1) {
            array.splice(index, 1);
        }
        return array;
    }

    const handlingAddChoice = () => {
        // handling updating choice choices
        if (selectedChoiceZone1) {
            setAvailableChoicesZone1(() =>
                availableChoicesZone1.filter(
                    (item) => item.stateKey !== selectedChoiceZone1.stateKey
                )
            );
            setSelectedChoiceZone1(null);
            
            if (selectedKeyPreviousZone1 === selectedChoiceZone1) {
                // remove in main answer
                let ans = {...answer};
                ans["zone1"] = removeValueInArray(ans["zone1"], selectedKeyPreviousZone1.stateKey);
                setAnswer(ans);

                // remove in zone 1 answer
                setAnswerZone1(() =>
                    answerZone1.filter(
                        (item) => item.stateKey !== selectedKeyPreviousZone1.stateKey
                    )
                );

                setSelectedKeyPreviousZone1(null);
            }
        } else if (selectedChoiceZone2) {
            setAvailableChoicesZone2(() =>
                availableChoicesZone2.filter(
                    (item) => item.stateKey !== selectedChoiceZone2.stateKey
                )
            );
            setSelectedChoiceZone2(null);

            if (selectedKeyPreviousZone2 === selectedChoiceZone2) {
                // remove in main answer
                let ans = {...answer};
                ans["zone2"][selectedKeyPreviousZone2.position] = removeValueInArray(ans["zone2"][selectedKeyPreviousZone2.position], selectedKeyPreviousZone2.stateKey);
                setAnswer(ans);
                
                // remove in zone 2 answer
                let ansZone2 = {...answerZone2};
                ansZone2[selectedKeyPreviousZone2.position] = answerZone2[selectedKeyPreviousZone2.position].filter(
                    (item) => item.stateKey !== selectedKeyPreviousZone2.stateKey
                );
                setAnswerZone2(ansZone2);

                setSelectedKeyPreviousZone2(null);
            }

        } else if (selectedChoiceZone3) {
            setAvailableChoicesZone3(() =>
                availableChoicesZone3.filter(
                    (item) => item.stateKey !== selectedChoiceZone3.stateKey
                )
            );
            setSelectedChoiceZone3(null);

            if (selectedKeyPreviousZone3 === selectedChoiceZone3) {
                // remove in main answer
                let ans = {...answer};
                ans["zone3"] = removeValueInArray(ans["zone3"], selectedKeyPreviousZone3.stateKey);
                setAnswer(ans);

                // remove in zone 3 answer
                setAnswerZone3(() =>
                    answerZone3.filter(
                        (item) => item.stateKey !== selectedKeyPreviousZone3.stateKey
                    )
                );
            }
        }
    }

    const handlingRemoveChoice = (curentAnswer, position) => {
        if (curentAnswer.zone === 1) {
            // remove in main answer
            let ans = {...answer};
            ans["zone1"] = removeValueInArray(ans["zone1"], curentAnswer.stateKey);
            setAnswer(ans);

            // remove in zone 1 answer
            setAnswerZone1(() =>
                answerZone1.filter(
                    (item) => item.stateKey !== curentAnswer.stateKey
                )
            );
        } else if (curentAnswer.zone === 2) {
            // remove in main answer
            let ans = {...answer};
            ans["zone2"][position] = removeValueInArray(ans["zone2"][position], curentAnswer.stateKey);
            setAnswer(ans);
            
            // remove in zone 2 answer
            let ansZone2 = {...answerZone2};
            ansZone2[position] = answerZone2[position].filter(
                (item) => item.stateKey !== curentAnswer.stateKey
            );
            setAnswerZone2(ansZone2);
        } else if (curentAnswer.zone === 3) {
            // remove in main answer
            let ans = {...answer};
            ans["zone3"] = removeValueInArray(ans["zone3"], curentAnswer.stateKey);
            setAnswer(ans);

            // remove in zone 3 answer
            setAnswerZone3(() =>
                answerZone3.filter(
                    (item) => item.stateKey !== curentAnswer.stateKey
                )
            );
        }

        // remove to choice
        if (curentAnswer.originalZone === 1) {
            setAvailableChoicesZone1((availableChoicesZone1) => [
                ...availableChoicesZone1,
                {
                    "shape": curentAnswer.shape,
                    "value": curentAnswer.value,
                    "style": curentAnswer.style,
                    "stateKey": curentAnswer.stateKey,
                }
            ]);
            setSelectedChoiceZone1(null);
            setSelectedKeyPreviousZone1(null);
        } else if (curentAnswer.originalZone === 2) {
            setAvailableChoicesZone2((availableChoicesZone2) => [
                ...availableChoicesZone2,
                {
                    "shape": curentAnswer.shape,
                    "value": curentAnswer.value,
                    "style": curentAnswer.style,
                    "stateKey": curentAnswer.stateKey,
                }
            ]);
            setSelectedChoiceZone2(null);
            setSelectedKeyPreviousZone2(null);
        } else if (curentAnswer.originalZone === 3) {
            setAvailableChoicesZone3((availableChoicesZone3) => [
                ...availableChoicesZone3,
                {
                    "shape": curentAnswer.shape,
                    "value": curentAnswer.value,
                    "style": curentAnswer.style,
                    "stateKey": curentAnswer.stateKey,
                }
            ]);
            setSelectedChoiceZone3(null);
            setSelectedKeyPreviousZone3(null);
        }
    }

    const handleClickAnswerZone1 = (answer) => {
        if (selectedKeyPreviousZone1 === null) {
            setSelectedChoiceZone1(answer);
            setSelectedKeyPreviousZone1(answer);
        }
    }

    const handleClickAnswerZone2 = (answer) => {
        if (selectedKeyPreviousZone2 === null) {
            setSelectedChoiceZone2(answer);
            setSelectedKeyPreviousZone2(answer);
        }
    }

    const handleClickAnswerZone3 = (answer) => {
        if (selectedKeyPreviousZone3 === null) {
            setSelectedChoiceZone3(answer);
            setSelectedKeyPreviousZone3(answer);
        }
    }

    const playAudio = (url) => {

        const previousUrl = playingAudioUrl;
        if (previousUrl !== "") {
            // we will set to empty to stop
            if (previousUrl !== url) {
                setPlayingAudioUrl("");
                refs.current[previousUrl].pause();

                // set play again
                setPlayingAudioUrl(url);
                refs.current[url].play();
            } else if (previousUrl === url) {
                // we will control the play or pause
                if (!refs.current[previousUrl].paused) {
                    setPlayingAudioUrl("");
                    refs.current[previousUrl].pause();
                } else {
                    setPlayingAudioUrl(previousUrl);
                    refs.current[previousUrl].play();
                }
            }
        } else {
            // play at initial
            setPlayingAudioUrl(url);
            refs.current[url].play();
        }
        
    }

    const handleEnded = () => {
        setPlayingAudioUrl("");
    }

    return (
        <Box
            sx={{
            }}
        >
            <Box sx={{
                    marginBottom: "20px",
                }}>
                <Button
                    sx={{
                        position: "relative",
                        outline: "none",
                        border: "none",
                        cursor: "pointer",
                        backgroundColor: "hsl(204,100%,47%)",
                        borderBottom: "5px solid hsl(204,100%,37%)",
                        borderRadius: "5px",
                        minWidth: "15em",
                        minHeight: "3em",
                        fontWeight: "bold",
                        textAlign: "left",
                        justifyContent: "left",
                        paddingLeft: "35px",
                        margin: "5px",
                        marginLeft: "15px",
                        color: "black",
                        "&:hover": {
                                backgroundColor: "hsl(204,100%,44%)",
                                borderBottomColor: "hsl(204,100%,34%)",
                            },
                    }}
                    onClick={() => playAudio(audioInfo.audioSrc)}
                >{audioInfo.value}
                    <Box component="img" 
                        src={playingAudioUrl === "" ? "data:image/png;base64,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"
                            : "data:image/png;base64,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"}
                        sx={{
                            position: "absolute",
                            left: "-14px",
                            top: "-2.5px",
                            cursor: "pointer",
                            fontWeight: "bold",
                            textAlign: "left",
                        }}
                        alt="Play Icon Img"
                    />
                    <audio ref={(el) => refs.current[audioInfo.audioSrc] = el} src={`${audioResources}${audioInfo.audioSrc}`} onEnded={handleEnded}/>
                </Button>
            </Box>

            <Box sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "780px",
                position: "relative",
                textAlign: "center",
            }}>

                {/* For Zone 1 */}
                <Box sx={{
                    borderBottom: "10px solid #5E5A76",
                    textAlign: "center",
                }}>
                    {/* For Header */}
                    <Box sx={{
                        textAlign: "center",
                        backgroundColor: "#7F7B9A",
                        color: "white",
                        borderBottomWidth: "10px",
                        borderBottomStyle: "solid",
                        borderBottomColor: "#5E5A76",
                        padding: "8px",
                        paddingRight: "20px",
                        fontSize: "1.25em",
                    }}>Zone 1</Box>

                    {/* For Body */}
                    <Box sx={{
                        backgroundColor: "#f2f2f2",
                        padding: "10px",
                        textAlign: "center",
                        height: "415px",
                    }}>
                        {/* For Choices */}
                        <Box sx={{
                            width: "220px",
                            height: "185px",
                            marginBottom: "10px",
                            padding: "10px",
                            backgroundColor: "transparent",
                            border: "1px dashed lightgrey",
                            textAlign: "center",
                        }}>
                            <Box sx={{
                                position: "relative",
                                height: "100%",
                                width: "100%",
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gridTemplateRows: "1fr 1fr",
                                placeItems: "center",
                                top: "0",
                                left: "0",
                                textAlign: "center",
                            }}>
                                {availableChoicesZone1.map((choice, index) => (
                                    <React.Fragment key={index}>
                                        {/* For Square */}
                                        {choice.shape === "square" && (
                                            <Box sx={{
                                                borderBottom: choice.style.borderBottom,
                                                position: "relative",
                                                backgroundColor: choice.style.backgroundColor,
                                                height: "42px",
                                                width: "42px",
                                                display: "inline-block",
                                                boxSizing: "content-box",
                                                padding: "4px",
                                                lineHeight: "0.8em",
                                                textAlign: "center",
                                                boxShadow:
                                                    selectedChoiceZone1 === choice
                                                        ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                        : "none",
                                                }}
                                                onClick={() => { handleChoiceClickZone1(choice) }}
                                                disabled={selectedChoiceZone1 === choice}
                                            >
                                                <Box sx={{
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    fontSize: "20px",
                                                    display: "inline-flex",
                                                    width: "100%",
                                                    height: "100%",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    userSelect: 'none',
                                                    pointerEvents: "none",
                                                    lineHeight: "0.8em",
                                                    textAlign: "center",
                                                }}>{choice.value}</Box>
                                            </Box>
                                        )}
                                        {/* For Triangle */}
                                        {choice.shape === "triangle" && (
                                            <Box sx={{
                                                borderBottom: "10px solid transparent",
                                                position: "relative",
                                                backgroundColor: "transparent",
                                                height: "42px",
                                                width: "62px",
                                                display: "inline-block",
                                                boxSizing: "content-box",
                                                padding: "4px",
                                                lineHeight: "0.8em",
                                                textAlign: "center",
                                                boxShadow:
                                                    selectedChoiceZone1 === choice
                                                        ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                        : "none",
                                                    }}
                                                onClick={() => { handleChoiceClickZone1(choice) }}
                                                disabled={selectedChoiceZone1 === choice}
                                            >
                                                <Box sx={{
                                                    position: "relative",
                                                    borderBottom: choice.style.borderBottom,
                                                    marginTop: "0px",
                                                    lineHeight: "0.8em",
                                                    textAlign: "center",
                                                }}>
                                                    <Box sx={{
                                                        borderLeft: "30px solid transparent",
                                                        borderRight: "30px solid transparent",
                                                        borderBottom: choice.style.mainBorderBottom,
                                                        lineHeight: "0.8em",
                                                        textAlign: "center",
                                                    }}>
                                                    </Box>
                                                    <Box sx={{
                                                        position: "absolute",
                                                        color: "white",
                                                        fontWeight: "bold",
                                                        fontSize: "20px",
                                                        textAlign: "center",
                                                        top: "25px",
                                                        left: "24px",
                                                        lineHeight: "0.8em"
                                                    }}>{choice.value}</Box>
                                                </Box>
                                            </Box>
                                        )}

                                        {/* For Circle  */}
                                        {choice.shape === "circle" && (
                                            <Box sx={{
                                                borderBottom: choice.style.borderBottom,
                                                position: "relative",
                                                backgroundColor: choice.style.backgroundColor,
                                                borderRadius: "25px",
                                                height: "37px",
                                                width: "42px",
                                                display: "inline-block",
                                                boxSizing: "content-box",
                                                padding: "4px",
                                                lineHeight: "0.8em",
                                                textAlign: "center",
                                                boxShadow:
                                                    selectedChoiceZone1 === choice
                                                        ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                        : "none",
                                                }}
                                                onClick={() => { handleChoiceClickZone1(choice) }}
                                                disabled={selectedChoiceZone1 === choice}
                                            >
                                                <Box sx={{
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    fontSize: "20px",
                                                    display: "inline-flex",
                                                    width: "100%",
                                                    height: "100%",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    userSelect: 'none',
                                                    pointerEvents: "none",
                                                    lineHeight: "0.8em",
                                                    textAlign: "center",
                                                }}>{choice.value}</Box>
                                            </Box>
                                        )}
                                    </React.Fragment>
                                ))}
                            </Box>
                        </Box>

                        {/* For Answer */}
                        <Box sx={{
                            height: "175px",
                            width: "220px",
                            borderTop: "10px solid rgb(91, 105, 106)",
                            backgroundColor: "white",
                            position: "relative",
                            display: "inline-block",
                            boxSizing: "border-box",
                            padding: "4px",
                            lineHeight: "0.8em",
                            textAlign: "center",
                            boxShadow:
                                selectedChoiceZone1 || selectedChoiceZone2 || selectedChoiceZone3
                                        ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                        : "none",
                            }}
                            onClick={() => handleClickAssignedZone1() }
                        >
                            <Box sx={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                                flexDirection: "column",
                                position: "absolute",
                                top: "-10px",
                                bottom: "0",
                                left: "0",
                                right: "0",
                                lineHeight: "0.8em",
                                textAlign: "center",
                            }}>
                                {/* If there is an answer to Zone 1 */}
                                {answerZone1.map((answer, answerIndex) => {
                                    return (
                                        <React.Fragment key={answerIndex}>
                                            {answer.zone === 1 && (
                                                <React.Fragment>
                                                    {/* For Square */}
                                                    {answer.shape === "square" && (
                                                        <Box 
                                                            sx={{
                                                                borderBottom: answer.style.borderBottom,
                                                                position: "relative",
                                                                backgroundColor: answer.style.backgroundColor,
                                                                height: "42px",
                                                                width: "42px",
                                                                display: "inline-block",
                                                                boxSizing: "content-box",
                                                                padding: "4px",
                                                                lineHeight: "0.8em",
                                                                textAlign: "center",
                                                                boxShadow: selectedKeyPreviousZone1 === answer 
                                                                    ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                                    : "none"
                                                            }}
                                                            onClick={() => {handleClickAnswerZone1(answer)}}
                                                        >
                                                            <Box 
                                                                sx={{
                                                                    color: "white",
                                                                    fontWeight: "bold",
                                                                    fontSize: "20px",
                                                                    display: "inline-flex",
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    userSelect: 'none',
                                                                    pointerEvents: "none",
                                                                    lineHeight: "0.8em",
                                                                    textAlign: "center",
                                                                }}
                                                            >{answer.value}
                                                            </Box>
                                                            {/* Close  */}
                                                            <Box
                                                                className="selected-close-btn"
                                                                sx={{
                                                                    right: "0px",
                                                                    top: "0px",
                                                                    display: "content-box",
                                                                    lineHeight: "0.8em",
                                                                    fontWeight: "bold",
                                                                    fontSize: "20px",
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleRemoveChoiceZone1(answer);
                                                                }}
                                                            >X</Box>
                                                        </Box>
                                                    )}
                                                    {/* For Triangle */}
                                                    {answer.shape === "triangle" && (
                                                        <Box 
                                                            sx={{
                                                                borderBottom: "10px solid transparent",
                                                                position: "relative",
                                                                backgroundColor: "transparent",
                                                                height: "42px",
                                                                width: "62px",
                                                                display: "inline-block",
                                                                boxSizing: "content-box",
                                                                padding: "4px",
                                                                lineHeight: "0.8em",
                                                                boxShadow: selectedKeyPreviousZone1 === answer 
                                                                        ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                                        : "none"
                                                            }}
                                                            onClick={() => {handleClickAnswerZone1(answer)}}
                                                        >
                                                            <Box sx={{
                                                                position: "relative",
                                                                borderBottom: answer.style.borderBottom,
                                                                marginTop: "0px",
                                                                lineHeight: "0.8em",
                                                                textAlign: "center",
                                                            }}>
                                                                <Box sx={{
                                                                    borderLeft: "30px solid transparent",
                                                                    borderRight: "30px solid transparent",
                                                                    borderBottom: answer.style.mainBorderBottom,
                                                                    lineHeight: "0.8em",
                                                                    textAlign: "center",
                                                                }}></Box>
                                                                <Box sx={{
                                                                    position: "absolute",
                                                                    color: "white",
                                                                    fontWeight: "bold",
                                                                    fontSize: "20px",
                                                                    textAlign: "center",
                                                                    top: "25px",
                                                                    left: "24px",
                                                                    lineHeight: "0.8em"
                                                                }}>{answer.value}</Box>
                                                                {/* Close  */}
                                                                <Box
                                                                    className="selected-close-btn"
                                                                    sx={{
                                                                        right: "0px",
                                                                        top: "0px",
                                                                        display: "content-box",
                                                                        lineHeight: "0.8em",
                                                                        fontWeight: "bold",
                                                                        fontSize: "20px",
                                                                    }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleRemoveChoiceZone1(answer);
                                                                    }}
                                                                >X</Box>
                                                            </Box>
                                                        </Box>
                                                    )}

                                                    {/* For Circle  */}
                                                    {answer.shape === "circle" && (
                                                        <Box sx={{
                                                                borderBottom: answer.style.borderBottom,
                                                                position: "relative",
                                                                backgroundColor: answer.style.backgroundColor,
                                                                borderRadius: "25px",
                                                                height: "37px",
                                                                width: "42px",
                                                                display: "inline-block",
                                                                boxSizing: "content-box",
                                                                padding: "4px",
                                                                lineHeight: "0.8em",
                                                                textAlign: "center",
                                                                boxShadow: selectedKeyPreviousZone1 === answer 
                                                                    ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                                    : "none"
                                                            }}
                                                            onClick={() => {handleClickAnswerZone1(answer)}}
                                                        >
                                                            <Box sx={{
                                                                color: "white",
                                                                fontWeight: "bold",
                                                                fontSize: "20px",
                                                                display: "inline-flex",
                                                                width: "100%",
                                                                height: "100%",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                userSelect: 'none',
                                                                pointerEvents: "none",
                                                                lineHeight: "0.8em",
                                                                textAlign: "center",
                                                            }}>{answer.value}
                                                            </Box>
                                                            {/* Close  */}
                                                            <Box 
                                                                className="selected-close-btn"
                                                                sx={{
                                                                    right: "0px",
                                                                    top: "0px",
                                                                    display: "content-box",
                                                                    lineHeight: "0.8em",
                                                                    fontWeight: "bold",
                                                                    fontSize: "20px",
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleRemoveChoiceZone1(answer);
                                                                }}
                                                            >X</Box>
                                                        </Box>
                                                    )}
                                                    
                                                    {/* For Box */}
                                                    {answer.shape === "box" && (
                                                        <Box sx={{
                                                            padding: "4px",
                                                            position: "relative",
                                                            height: "27px",
                                                            width: "192px",
                                                            display: "inline-block",
                                                            boxSizing: "content-box",
                                                            backgroundColor: "#aad6e7",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                            boxShadow: selectedKeyPreviousZone1 === answer 
                                                                ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                                : "none"
                                                            }}
                                                            onClick={() => {handleClickAnswerZone1(answer)}}
                                                        >
                                                            <Box sx={{
                                                                fontWeight: "bold",
                                                                fontSize: "22px",
                                                                display: "inline-flex",
                                                                width: "100%",
                                                                height: "100%",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                userSelect: 'none',
                                                                pointerEvents: "none",
                                                                lineHeight: "0.8em",
                                                                textAlign: "center",
                                                            }}>{answer.value}</Box>
                                                            {/* Close  */}
                                                            <Box
                                                                className="selected-close-btn"
                                                                sx={{
                                                                    right: "0px",
                                                                    top: "0px",
                                                                    display: "content-box",
                                                                    lineHeight: "0.8em",
                                                                    fontWeight: "bold",
                                                                    fontSize: "20px",
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleRemoveChoiceZone1(answer);
                                                                }}
                                                            >X</Box>
                                                        </Box>
                                                    )}
                                                </React.Fragment>
                                        )}
                                        </React.Fragment>
                                    )
                                })}
                            </Box>
                        </Box>
                    </Box>
                </Box>

                {/* For Zone 2 */}
                <Box sx={{
                    borderBottom: "10px solid #38546C",
                    textAlign: "center",
                }}>
                    {/* For Header */}
                    <Box sx={{
                        textAlign: "center",
                        backgroundColor: "#4A7090",
                        color: "white",
                        borderBottomWidth: "10px",
                        borderBottomStyle: "solid",
                        borderBottomColor: "#38546C",
                        padding: "8px",
                        paddingRight: "20px",
                        fontSize: "1.25em",
                    }}>Zone 2</Box>

                    {/* For Body */}
                    <Box sx={{
                        display: "flex",
                        justifyContent: "space-around",
                        width: "280px",
                        backgroundColor: "#f2f2f2",
                        padding: "10px",
                        textAlign: "center",
                    }}>
                        {/* For Left Answer Box */}
                        <Box sx={{
                                height: "395px",
                                width: "85px",
                                borderTop: "10px solid rgb(91, 105, 106)",
                                backgroundColor: "white",
                                fontSize: "24px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                position: "relative",
                                boxSizing: "border-box",
                                padding: "4px",
                                lineHeight: "0.8em",
                                textAlign: "center",boxShadow:
                                selectedChoiceZone1 || selectedChoiceZone2 || selectedChoiceZone3
                                        ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                        : "none",
                            }}
                            onClick={() => handleClickAssignedZone2("left") }
                        >L
                            <Box sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-around",
                                alignItems: "center",
                                position: "absolute",
                                top: "-10px",
                                bottom: "0",
                                left: "0",
                                right: "0",
                                fontSize: "24px",
                                lineHeight: "0.8em",
                                textAlign: "center",
                            }}>
                                {/* If there is an answer to Zone 2 Left */}
                                {answerZone2["left"].map((answer, answerIndex) => (
                                    <React.Fragment key={answerIndex}>
                                        {answer.zone === 2 && (
                                            <React.Fragment>
                                                {/* For Square */}
                                                {answer.shape === "square" && (
                                                    <Box sx={{
                                                        borderBottom: answer.style.borderBottom,
                                                        position: "relative",
                                                        backgroundColor: answer.style.backgroundColor,
                                                        height: "42px",
                                                        width: "42px",
                                                        display: "inline-block",
                                                        boxSizing: "content-box",
                                                        padding: "4px",
                                                        lineHeight: "0.8em",
                                                        textAlign: "center",
                                                        boxShadow: selectedKeyPreviousZone2 === answer 
                                                            ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                            : "none"
                                                        }}
                                                        onClick={() => {handleClickAnswerZone2(answer)}}
                                                    >
                                                        <Box sx={{
                                                            color: "white",
                                                            fontWeight: "bold",
                                                            fontSize: "20px",
                                                            display: "inline-flex",
                                                            width: "100%",
                                                            height: "100%",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            userSelect: 'none',
                                                            pointerEvents: "none",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                        }}>{answer.value}
                                                        </Box>
                                                        {/* Close  */}
                                                        <Box
                                                            className="selected-close-btn"
                                                            sx={{
                                                                right: "0px",
                                                                top: "0px",
                                                                display: "content-box",
                                                                lineHeight: "0.8em",
                                                                fontWeight: "bold",
                                                                fontSize: "20px",
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleRemoveChoiceZone2(answer, "left");
                                                            }}
                                                        >X</Box>
                                                    </Box>
                                                )}
                                                {/* For Triangle */}
                                                {answer.shape === "triangle" && (
                                                    <Box sx={{
                                                            borderBottom: "10px solid transparent",
                                                            position: "relative",
                                                            backgroundColor: "transparent",
                                                            height: "42px",
                                                            width: "62px",
                                                            display: "inline-block",
                                                            boxSizing: "content-box",
                                                            padding: "4px",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                            boxShadow: selectedKeyPreviousZone2 === answer 
                                                                ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                                : "none"
                                                        }}
                                                        onClick={() => {handleClickAnswerZone2(answer)}}
                                                    >
                                                        <Box sx={{
                                                            position: "relative",
                                                            borderBottom: answer.style.borderBottom,
                                                            marginTop: "0px",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                        }}>
                                                            <Box sx={{
                                                                borderLeft: "30px solid transparent",
                                                                borderRight: "30px solid transparent",
                                                                borderBottom: answer.style.mainBorderBottom,
                                                                lineHeight: "0.8em",
                                                                textAlign: "center",
                                                            }}></Box>
                                                            <Box sx={{
                                                                position: "absolute",
                                                                color: "white",
                                                                fontWeight: "bold",
                                                                fontSize: "20px",
                                                                textAlign: "center",
                                                                top: "25px",
                                                                left: "24px",
                                                                lineHeight: "0.8em"
                                                            }}>{answer.value}</Box>
                                                            {/* Close  */}
                                                            <Box
                                                                className="selected-close-btn"
                                                                sx={{
                                                                    right: "0px",
                                                                    top: "0px",
                                                                    display: "content-box",
                                                                    lineHeight: "0.8em",
                                                                    fontWeight: "bold",
                                                                    fontSize: "20px",
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleRemoveChoiceZone2(answer, "left");
                                                                }}
                                                            >X</Box>
                                                        </Box>
                                                    </Box>
                                                )}

                                                {/* For Circle  */}
                                                {answer.shape === "circle" && (
                                                    <Box sx={{
                                                            borderBottom: answer.style.borderBottom,
                                                            position: "relative",
                                                            backgroundColor: answer.style.backgroundColor,
                                                            borderRadius: "25px",
                                                            height: "37px",
                                                            width: "42px",
                                                            display: "inline-block",
                                                            boxSizing: "content-box",
                                                            padding: "4px",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                            boxShadow: selectedKeyPreviousZone2 === answer 
                                                            ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                            : "none"
                                                        }}
                                                        onClick={() => {handleClickAnswerZone2(answer)}}
                                                    >
                                                        <Box sx={{
                                                            color: "white",
                                                            fontWeight: "bold",
                                                            fontSize: "20px",
                                                            display: "inline-flex",
                                                            width: "100%",
                                                            height: "100%",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            userSelect: 'none',
                                                            pointerEvents: "none",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                        }}>{answer.value}
                                                        </Box>
                                                        {/* Close  */}
                                                        <Box 
                                                            className="selected-close-btn"
                                                            sx={{
                                                                right: "0px",
                                                                top: "0px",
                                                                display: "content-box",
                                                                lineHeight: "0.8em",
                                                                fontWeight: "bold",
                                                                fontSize: "20px",
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleRemoveChoiceZone2(answer, "left");
                                                            }}
                                                        >X</Box>
                                                    </Box>
                                                )}

                                                {/* For Box */}
                                                {answer.shape === "box" && (
                                                    <Box sx={{
                                                        padding: "4px",
                                                        position: "relative",
                                                        height: "27px",
                                                        width: "192px",
                                                        display: "inline-block",
                                                        boxSizing: "content-box",
                                                        backgroundColor: "#aad6e7",
                                                        lineHeight: "0.8em",
                                                        textAlign: "center",
                                                        boxShadow: selectedKeyPreviousZone2 === answer 
                                                            ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                            : "none"
                                                        }}
                                                        onClick={() => {handleClickAnswerZone2(answer)}}
                                                    >
                                                        <Box sx={{
                                                            fontWeight: "bold",
                                                            fontSize: "22px",
                                                            display: "inline-flex",
                                                            width: "100%",
                                                            height: "100%",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            userSelect: 'none',
                                                            pointerEvents: "none",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                        }}>{answer.value}</Box>
                                                        {/* Close  */}
                                                        <Box
                                                            className="selected-close-btn"
                                                            sx={{
                                                                right: "0px",
                                                                top: "0px",
                                                                display: "content-box",
                                                                lineHeight: "0.8em",
                                                                fontWeight: "bold",
                                                                fontSize: "20px",
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleRemoveChoiceZone2(answer, "left");
                                                            }}
                                                        >X</Box>
                                                    </Box>
                                                )}
                                            </React.Fragment>
                                    )}
                                    </React.Fragment>
                                ))}
                            </Box>
                        </Box>

                        {/* For Main Choices */}
                        <Box sx={{
                            width: "70px",
                            height: "385px",
                            padding: "5px",
                            backgroundColor: "transparent",
                            border: "1px dashed lightgrey",
                            textAlign: "center",
                        }}>
                            <Box sx={{
                                position: "relative",
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                                flexDirection: "column",
                                height: "100%",
                                top: "0",
                                left: "0",
                                textAlign: "center",
                            }}>
                                {/* For Choices */}
                                {availableChoicesZone2.map((choice, index) => (
                                    <React.Fragment key={index}>
                                        {/* For Triangle */}
                                        {choice.shape === "triangle" && (
                                            <Box sx={{
                                                borderBottom: "10px solid transparent",
                                                position: "relative",
                                                backgroundColor: "transparent",
                                                height: "42px",
                                                width: "62px",
                                                display: "inline-block",
                                                boxSizing: "content-box",
                                                padding: "4px",
                                                lineHeight: "0.8em",
                                                textAlign: "center",
                                                boxShadow:
                                                    selectedChoiceZone2 === choice
                                                        ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                        : "none",
                                                    }}
                                                onClick={() => { handleChoiceClickZone2(choice) }}
                                                disabled={selectedChoiceZone2 === choice}
                                            >
                                                <Box sx={{
                                                    position: "relative",
                                                    borderBottom: choice.style.borderBottom,
                                                    marginTop: "0px",
                                                    lineHeight: "0.8em",
                                                    textAlign: "center",
                                                }}>
                                                    <Box sx={{
                                                        borderLeft: "30px solid transparent",
                                                        borderRight: "30px solid transparent",
                                                        borderBottom: choice.style.mainBorderBottom,
                                                        lineHeight: "0.8em",
                                                        textAlign: "center",
                                                    }}>
                                                    </Box>
                                                    <Box sx={{
                                                        position: "absolute",
                                                        color: "white",
                                                        fontWeight: "bold",
                                                        fontSize: "20px",
                                                        textAlign: "center",
                                                        top: "25px",
                                                        left: "24px",
                                                        lineHeight: "0.8em"
                                                    }}>{choice.value}</Box>
                                                </Box>
                                            </Box>
                                        )}

                                        {/* For Circle  */}
                                        {choice.shape === "circle" && (
                                            <Box sx={{
                                                borderBottom: choice.style.borderBottom,
                                                position: "relative",
                                                backgroundColor: choice.style.backgroundColor,
                                                borderRadius: "25px",
                                                height: "37px",
                                                width: "42px",
                                                display: "inline-block",
                                                boxSizing: "content-box",
                                                padding: "4px",
                                                lineHeight: "0.8em",
                                                textAlign: "center",
                                                boxShadow:
                                                    selectedChoiceZone2 === choice
                                                        ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                        : "none",
                                                }}
                                                onClick={() => { handleChoiceClickZone2(choice) }}
                                                disabled={selectedChoiceZone2 === choice}
                                            >
                                                <Box sx={{
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    fontSize: "20px",
                                                    display: "inline-flex",
                                                    width: "100%",
                                                    height: "100%",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    userSelect: 'none',
                                                    pointerEvents: "none",
                                                    lineHeight: "0.8em",
                                                    textAlign: "center",
                                                }}>{choice.value}</Box>
                                            </Box>
                                        )}

                                        {/* For Square */}
                                        {choice.shape === "square" && (
                                            <Box sx={{
                                                borderBottom: choice.style.borderBottom,
                                                position: "relative",
                                                backgroundColor: choice.style.backgroundColor,
                                                height: "42px",
                                                width: "42px",
                                                display: "inline-block",
                                                boxSizing: "content-box",
                                                padding: "4px",
                                                lineHeight: "0.8em",
                                                textAlign: "center",
                                                boxShadow:
                                                    selectedChoiceZone2 === choice
                                                        ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                        : "none",
                                                }}
                                                onClick={() => { handleChoiceClickZone2(choice) }}
                                                disabled={selectedChoiceZone2 === choice}
                                            >
                                                <Box sx={{
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    fontSize: "20px",
                                                    display: "inline-flex",
                                                    width: "100%",
                                                    height: "100%",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    userSelect: 'none',
                                                    pointerEvents: "none",
                                                    lineHeight: "0.8em",
                                                    textAlign: "center",
                                                }}>{choice.value}</Box>
                                            </Box>
                                        )}
                                    </React.Fragment>
                                ))}
                            </Box>
                        </Box>

                        {/* For Right Answer Box */}
                        <Box sx={{
                                height: "395px",
                                width: "85px",
                                borderTop: "10px solid rgb(91, 105, 106)",
                                backgroundColor: "white",
                                fontSize: "24px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                position: "relative",
                                boxSizing: "border-box",
                                padding: "4px",
                                lineHeight: "0.8em",
                                textAlign: "center",boxShadow:
                                selectedChoiceZone1 || selectedChoiceZone2 || selectedChoiceZone3
                                        ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                        : "none",
                            }}
                            onClick={() => handleClickAssignedZone2("right") }
                        >R
                            <Box sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-around",
                                alignItems: "center",
                                position: "absolute",
                                top: "-10px",
                                bottom: "0",
                                left: "0",
                                right: "0",
                                fontSize: "24px",
                                lineHeight: "0.8em",
                                textAlign: "center",
                            }}>
                                {/* If there is an answer to Zone 2 Left */}
                                {answerZone2["right"].map((answer, answerIndex) => (
                                    <React.Fragment key={answerIndex}>
                                        {answer.zone === 2 && (
                                            <React.Fragment>
                                                {/* For Square */}
                                                {answer.shape === "square" && (
                                                    <Box sx={{
                                                        borderBottom: answer.style.borderBottom,
                                                        position: "relative",
                                                        backgroundColor: answer.style.backgroundColor,
                                                        height: "42px",
                                                        width: "42px",
                                                        display: "inline-block",
                                                        boxSizing: "content-box",
                                                        padding: "4px",
                                                        lineHeight: "0.8em",
                                                        textAlign: "center",
                                                        boxShadow: selectedKeyPreviousZone2 === answer 
                                                            ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                            : "none"
                                                        }}
                                                        onClick={() => {handleClickAnswerZone2(answer)}}
                                                    >
                                                        <Box sx={{
                                                            color: "white",
                                                            fontWeight: "bold",
                                                            fontSize: "20px",
                                                            display: "inline-flex",
                                                            width: "100%",
                                                            height: "100%",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            userSelect: 'none',
                                                            pointerEvents: "none",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                        }}>{answer.value}
                                                        </Box>
                                                        {/* Close  */}
                                                        <Box
                                                            className="selected-close-btn"
                                                            sx={{
                                                                right: "0px",
                                                                top: "0px",
                                                                display: "content-box",
                                                                lineHeight: "0.8em",
                                                                fontWeight: "bold",
                                                                fontSize: "20px",
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleRemoveChoiceZone2(answer, "right");
                                                            }}
                                                        >X</Box>
                                                    </Box>
                                                )}
                                                {/* For Triangle */}
                                                {answer.shape === "triangle" && (
                                                    <Box sx={{
                                                        borderBottom: "10px solid transparent",
                                                        position: "relative",
                                                        backgroundColor: "transparent",
                                                        height: "42px",
                                                        width: "62px",
                                                        display: "inline-block",
                                                        boxSizing: "content-box",
                                                        padding: "4px",
                                                        lineHeight: "0.8em",
                                                        textAlign: "center",
                                                        boxShadow: selectedKeyPreviousZone2 === answer 
                                                            ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                            : "none"
                                                        }}
                                                        onClick={() => {handleClickAnswerZone2(answer)}}
                                                    >
                                                        <Box sx={{
                                                            position: "relative",
                                                            borderBottom: answer.style.borderBottom,
                                                            marginTop: "0px",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                        }}>
                                                            <Box sx={{
                                                                borderLeft: "30px solid transparent",
                                                                borderRight: "30px solid transparent",
                                                                borderBottom: answer.style.mainBorderBottom,
                                                                lineHeight: "0.8em",
                                                                textAlign: "center",
                                                            }}></Box>
                                                            <Box sx={{
                                                                position: "absolute",
                                                                color: "white",
                                                                fontWeight: "bold",
                                                                fontSize: "20px",
                                                                textAlign: "center",
                                                                top: "25px",
                                                                left: "24px",
                                                                lineHeight: "0.8em"
                                                            }}>{answer.value}</Box>
                                                            {/* Close  */}
                                                            <Box
                                                                className="selected-close-btn"
                                                                sx={{
                                                                    right: "0px",
                                                                    top: "0px",
                                                                    display: "content-box",
                                                                    lineHeight: "0.8em",
                                                                    fontWeight: "bold",
                                                                    fontSize: "20px",
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleRemoveChoiceZone2(answer, "right");
                                                                }}
                                                            >X</Box>
                                                        </Box>
                                                    </Box>
                                                )}

                                                {/* For Circle  */}
                                                {answer.shape === "circle" && (
                                                    <Box sx={{
                                                        borderBottom: answer.style.borderBottom,
                                                        position: "relative",
                                                        backgroundColor: answer.style.backgroundColor,
                                                        borderRadius: "25px",
                                                        height: "37px",
                                                        width: "42px",
                                                        display: "inline-block",
                                                        boxSizing: "content-box",
                                                        padding: "4px",
                                                        lineHeight: "0.8em",
                                                        textAlign: "center",
                                                        boxShadow: selectedKeyPreviousZone2 === answer 
                                                            ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                            : "none"
                                                        }}
                                                        onClick={() => {handleClickAnswerZone2(answer)}}
                                                    >
                                                        <Box sx={{
                                                            color: "white",
                                                            fontWeight: "bold",
                                                            fontSize: "20px",
                                                            display: "inline-flex",
                                                            width: "100%",
                                                            height: "100%",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            userSelect: 'none',
                                                            pointerEvents: "none",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                        }}>{answer.value}
                                                        </Box>
                                                        {/* Close  */}
                                                        <Box
                                                            className="selected-close-btn"
                                                            sx={{
                                                                right: "0px",
                                                                top: "0px",
                                                                display: "content-box",
                                                                lineHeight: "0.8em",
                                                                fontWeight: "bold",
                                                                fontSize: "20px",
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleRemoveChoiceZone2(answer, "right");
                                                            }}
                                                        >X</Box>
                                                    </Box>
                                                )}
                                                
                                                {/* For Box */}
                                                {answer.shape === "box" && (
                                                    <Box sx={{
                                                            padding: "4px",
                                                            position: "relative",
                                                            height: "27px",
                                                            width: "192px",
                                                            display: "inline-block",
                                                            boxSizing: "content-box",
                                                            backgroundColor: "#aad6e7",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                            boxShadow: selectedKeyPreviousZone2 === answer 
                                                            ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                            : "none"
                                                        }}
                                                        onClick={() => {handleClickAnswerZone2(answer)}}
                                                    >
                                                        <Box sx={{
                                                            fontWeight: "bold",
                                                            fontSize: "22px",
                                                            display: "inline-flex",
                                                            width: "100%",
                                                            height: "100%",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            userSelect: 'none',
                                                            pointerEvents: "none",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                        }}>{answer.value}</Box>
                                                        {/* Close  */}
                                                        <Box
                                                            className="selected-close-btn"
                                                            sx={{
                                                                right: "0px",
                                                                top: "0px",
                                                                display: "content-box",
                                                                lineHeight: "0.8em",
                                                                fontWeight: "bold",
                                                                fontSize: "20px",
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleRemoveChoiceZone2(answer, "right");
                                                            }}
                                                        >X</Box>
                                                    </Box>
                                                )}
                                            </React.Fragment>
                                    )}
                                    </React.Fragment>
                                ))}
                            </Box>
                        </Box>
                    </Box>
                </Box>

                {/* For Zone 3 */}
                <Box sx={{
                    borderBottom: "10px solid #38546C",
                    textAlign: "center",
                }}>
                    {/* For Header */}
                    <Box sx={{
                        textAlign: "center",
                        backgroundColor: "#3A9498",
                        color: "white",
                        borderBottomWidth: "10px",
                        borderBottomStyle: "solid",
                        borderBottomColor: "#2C6F72",
                        padding: "8px",
                        paddingRight: "20px",
                        fontSize: "1.25em",
                    }}>Zone 3</Box>

                    {/* For Body */}
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: "1",
                        width: "230px",
                        backgroundColor: "#f2f2f2",
                        padding: "10px",
                        textAlign: "center",
                    }}>

                        {/* For Choices */}
                        <Box sx={{
                            backgroundColor: "transparent",
                            flexGrow: "1",
                            marginBottom: "10px",
                            width: "210px",
                            padding: "10px",
                            border: "1px dashed lightgrey",
                            textAlign: "center",
                        }}>
                            <Box sx={{
                                position: "relative",
                                height: "265px",
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-around",
                                alignItems: "center",
                                top: "0",
                                left: "0",
                                textAlign: "center",
                            }}>
                                {availableChoicesZone3.map((choice, index) => (
                                    <Box key={index} 
                                            sx={{
                                            padding: "4px",
                                            borderBottom: "10px solid rgb(52, 148, 186)",
                                            position: "relative",
                                            height: "27px",
                                            width: "192px",
                                            display: "inline-block",
                                            boxSizing: "content-box",
                                            backgroundColor: "#aad6e7",
                                            lineHeight: "0.8em",
                                            textAlign: "center",boxShadow:
                                            selectedChoiceZone3 === choice
                                                ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                : "none",
                                            }}
                                            onClick={() => { handleChoiceClickZone3(choice) }}
                                            disabled={selectedChoiceZone3 === choice}
                                        >
                                        <Box sx={{
                                            fontWeight: "bold",
                                            fontSize: "22px",
                                            display: "inline-flex",
                                            width: "100%",
                                            height: "100%",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            userSelect: 'none',
                                            pointerEvents: "none",
                                            lineHeight: "0.8em",
                                            textAlign: "center",
                                        }}>{choice.value}</Box>
                                    </Box>
                                ))}
                            </Box>
                        </Box>

                        {/* For Answer Box */}
                        <Box sx={{
                            height: "100px",
                            width: "210px",
                            borderTop: "10px solid rgb(91, 105, 106)",
                            backgroundColor: "white",
                            position: "relative",
                            display: "inline-block",
                            boxSizing: "border-box",
                            padding: "4px",
                            lineHeight: "0.8em",
                            textAlign: "center",
                            boxShadow:
                                selectedChoiceZone3 || selectedChoiceZone1 || selectedChoiceZone2
                                        ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                        : "none",
                            }}
                        onClick={() => handleClickAssignedZone3(answer.stateKey)}>
                            <Box sx={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                                // flexDirection: "column",
                                position: "absolute",
                                top: "-10px",
                                bottom: "0",
                                left: "0",
                                right: "0",
                                lineHeight: "0.8em",
                                textAlign: "center",
                            }}>
                                {/* If there is an answer to Zone 3 */}
                                {answerZone3.map((answer, answerIndex) => (
                                    <React.Fragment key={answerIndex}>
                                        {answer.zone === 3 && (
                                            <React.Fragment>
                                                {/* For Square */}
                                                {answer.shape === "square" && (
                                                    <Box sx={{
                                                        borderBottom: answer.style.borderBottom,
                                                            position: "relative",
                                                            backgroundColor: answer.style.backgroundColor,
                                                            height: "42px",
                                                            width: "42px",
                                                            display: "inline-block",
                                                            boxSizing: "content-box",
                                                            padding: "4px",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                            boxShadow: selectedKeyPreviousZone3 === answer 
                                                                ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                                : "none"
                                                        }}
                                                        onClick={() => {handleClickAnswerZone3(answer)}}
                                                    >
                                                        <Box sx={{
                                                            color: "white",
                                                            fontWeight: "bold",
                                                            fontSize: "20px",
                                                            display: "inline-flex",
                                                            width: "100%",
                                                            height: "100%",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            userSelect: 'none',
                                                            pointerEvents: "none",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                        }}>{answer.value}
                                                        </Box>
                                                        {/* Close  */}
                                                        <Box
                                                            className="selected-close-btn"
                                                            sx={{
                                                                right: "0px",
                                                                top: "0px",
                                                                display: "content-box",
                                                                lineHeight: "0.8em",
                                                                fontWeight: "bold",
                                                                fontSize: "20px",
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleRemoveChoiceZone1(answer);
                                                            }}
                                                        >X</Box>
                                                    </Box>
                                                )}
                                                {/* For Triangle */}
                                                {answer.shape === "triangle" && (
                                                    <Box sx={{
                                                            borderBottom: "10px solid transparent",
                                                            position: "relative",
                                                            backgroundColor: "transparent",
                                                            height: "42px",
                                                            width: "62px",
                                                            display: "inline-block",
                                                            boxSizing: "content-box",
                                                            padding: "4px",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                            boxShadow: selectedKeyPreviousZone3 === answer 
                                                            ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                            : "none"
                                                        }}
                                                        onClick={() => {handleClickAnswerZone3(answer)}}
                                                    >
                                                        <Box sx={{
                                                            position: "relative",
                                                            borderBottom: answer.style.borderBottom,
                                                            marginTop: "0px",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                        }}>
                                                            <Box sx={{
                                                                borderLeft: "30px solid transparent",
                                                                borderRight: "30px solid transparent",
                                                                borderBottom: answer.style.mainBorderBottom,
                                                                lineHeight: "0.8em",
                                                                textAlign: "center",
                                                            }}></Box>
                                                            <Box sx={{
                                                                position: "absolute",
                                                                color: "white",
                                                                fontWeight: "bold",
                                                                fontSize: "20px",
                                                                textAlign: "center",
                                                                top: "25px",
                                                                left: "24px",
                                                                lineHeight: "0.8em"
                                                            }}>{answer.value}</Box>
                                                            {/* Close  */}
                                                            <Box
                                                                className="selected-close-btn"
                                                                sx={{
                                                                    right: "0px",
                                                                    top: "0px",
                                                                    display: "content-box",
                                                                    lineHeight: "0.8em",
                                                                    fontWeight: "bold",
                                                                    fontSize: "20px",
                                                                }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleRemoveChoiceZone1(answer);
                                                                }}
                                                            >X</Box>
                                                        </Box>
                                                    </Box>
                                                )}

                                                {/* For Circle  */}
                                                {answer.shape === "circle" && (
                                                    <Box sx={{
                                                            borderBottom: answer.style.borderBottom,
                                                            position: "relative",
                                                            backgroundColor: answer.style.backgroundColor,
                                                            borderRadius: "25px",
                                                            height: "37px",
                                                            width: "42px",
                                                            display: "inline-block",
                                                            boxSizing: "content-box",
                                                            padding: "4px",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                            boxShadow: selectedKeyPreviousZone3 === answer 
                                                                ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                                : "none"
                                                        }}
                                                        onClick={() => {handleClickAnswerZone3(answer)}}
                                                    >
                                                        <Box sx={{
                                                            color: "white",
                                                            fontWeight: "bold",
                                                            fontSize: "20px",
                                                            display: "inline-flex",
                                                            width: "100%",
                                                            height: "100%",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            userSelect: 'none',
                                                            pointerEvents: "none",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                        }}>{answer.value}
                                                        </Box>
                                                        {/* Close  */}
                                                        <Box
                                                            className="selected-close-btn"
                                                            sx={{
                                                                right: "0px",
                                                                top: "0px",
                                                                display: "content-box",
                                                                lineHeight: "0.8em",
                                                                fontWeight: "bold",
                                                                fontSize: "20px",
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleRemoveChoiceZone1(answer);
                                                            }}
                                                        >X</Box>
                                                    </Box>
                                                )}

                                                {/* For Box */}
                                                {answer.shape === "box" && (
                                                    <Box sx={{
                                                            padding: "4px",
                                                            position: "relative",
                                                            height: "27px",
                                                            width: "192px",
                                                            display: "inline-block",
                                                            boxSizing: "content-box",
                                                            backgroundColor: "#aad6e7",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                            boxShadow: selectedKeyPreviousZone3 === answer 
                                                                ? "rgb(199, 0, 199) 0px 0px 0px 3px"
                                                                : "none"
                                                        }}
                                                        onClick={() => {handleClickAnswerZone3(answer)}}
                                                    >
                                                        <Box sx={{
                                                            fontWeight: "bold",
                                                            fontSize: "22px",
                                                            display: "inline-flex",
                                                            width: "100%",
                                                            height: "100%",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            userSelect: 'none',
                                                            pointerEvents: "none",
                                                            lineHeight: "0.8em",
                                                            textAlign: "center",
                                                        }}>{answer.value}</Box>
                                                        {/* Close  */}
                                                        <Box
                                                            className="selected-close-btn"
                                                            sx={{
                                                                right: "0px",
                                                                top: "0px",
                                                                display: "content-box",
                                                                lineHeight: "0.8em",
                                                                fontWeight: "bold",
                                                                fontSize: "20px",
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleRemoveChoiceZone3(answer);
                                                            }}
                                                        >X</Box>
                                                    </Box>
                                                )}
                                            </React.Fragment>
                                    )}
                                    </React.Fragment>
                                ))}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};